
<div class="container">
    <span>
        <!-- <div class="demoarea" (click)="goToSignupPage()" style="background-color: yellow; max-height: 35xpx;" *ngIf="demoMode">
            <span style="color: black; margin-left: 50px;">Demo Mode (Click here to create free account) </span>
        </div> -->
        <div style="display: flex;   width: 100%;
        ">
            <span style="flex: 1;" class="apparea">
                <div class="appheader">
                    <app-header></app-header>
                </div>
                <router-outlet></router-outlet>
                <app-footer></app-footer>
            </span>
        </div>
    </span>
</div>


